import React, { useEffect, useRef, useState } from 'react';
import {
  Box, Button, Icon, Loading,
} from '@roo/roo';
import styled, { createGlobalStyle } from 'styled-components';
import { useHistory } from 'react-router-dom';
import Cls from 'classnames';
import { get } from 'lodash';
import Header from '@components/HeaderWithoutMenu';
import { PAGE_TYPE } from '@utils/config';
import step_img_one from '@assets/images/apply/one.png';
import step_img_one_h from '@assets/images/apply/one-hui.png';
import step_img_two from '@assets/images/apply/two.png';
import step_img_two_h from '@assets/images/apply/two--hui.png';
import step_img_three from '@assets/images/apply/three.png';
import step_img_three_h from '@assets/images/apply/three-hui.png';
import { signUserAgreement } from '@assets/apis/base';
import { useUserData } from '@components/UserData';
import { Agreement } from '../../declare/Agreement';
import { Footer, useFormSave } from './Footer';
import TimeLess from '../timeless';
import Success from '../success';
import { useSimpleContext } from '../_context';

export const step_imgs = ['', step_img_one, step_img_two, step_img_three];
export const step_imgs_h = ['', step_img_one_h, step_img_two_h, step_img_three_h];

const GlobalStyle = createGlobalStyle`
  html{
    overflow: hidden;
  }
  body{
    overflow: hidden;
    .roo-btn.roo-btn-primary {
    background-color: #222;
    border-color: #222;
    }
    .roo-btn {
    border-radius: 0;
    }
    .cont{
      //height: 80vh;
      height: calc(100vh - 70px - 67.5px);
    }
  }
`;

const Root = styled.div`
  background-color: #e1e2e6;
  .wrap {
    margin: 70px 24px 24px;
  }
  .apply {
    padding-bottom: 100px;
    position: relative;
  }

  .upload {
    background: #ffffff;
    border: 1px solid #cccccc;
    border-radius: 2px;
    height: 94px;
    text-align: center;
    font-size: 14px;
    color: #666666;
    padding-top: 20px;

    > p {
      margin-top: 8px;

      &:last-child {
        font-size: 12px;
        color: #999999;
      }
    }
  }
  .form-title {
    .sub-title {
      display: block;
      margin-top: 8px;
      margin-left: 0;
      color: #222222;
    }
    .sub-title-inline {
      margin-left: 8px;
      color: #222222;
    }
  }
  .t-info {
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    line-height: 14px;
    text-align: left;
    margin-bottom: 24px;
    display: inline-block;
    i {
      margin-right: 4px;
      position: relative;
      top: -1px;
    }
  }
  .roo-input-number {
    input {
      width: calc(100% - 120px);
      text-align: left;
      margin-left: 42px;
    }
  }

  .patch-tips {
    width: 634px;
    margin: auto;
    //padding-left: 30px;
    font-size: 16px;
    color: #222222;
    font-weight: 500;

    .info {
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      line-height: 14px;
      text-align: left;
      margin-top: 8px;
    }
  }
  .f-recommend {
    .roo-input-required {
      position: relative;
      left: -13px;
    }
  }
  .field-required-label-h {
    &::before {
      content: '*';
      color: red;
      margin-right: 6px;
    }
  }
  .head {
    .over-tip {
      font-size: 14px;
    }
  }
  .roo-upload-list-item {
    color: #222;
  }
  .form-btn-x {
    position: fixed;
    width: calc(100vw - 244px);
    background: #ffffff;
    box-shadow: 0 -2px 6px 0 rgb(0 0 0 / 6%);
    margin-bottom: 0;
    margin-left: 0;
    bottom: 0;
    padding: 10px 0;
    min-width: 980px;
  }
  .wrap {
    .roo-checkbox input:checked + .custom-checkbox {
      background-color: #ffcc33;
      border-color: #ffcc33 !important;
    }
    .roo-radio input:checked + .custom-radio {
      background-color: #ffcc33;
      border-color: #ffcc33 !important;
    }
  }
  .roo-input-required {
    padding-left: 3px;
  }
  .roo-checkbox input:checked + .custom-checkbox::before {
    border-color: #000;
  }

  .file-full {
    .roo-upload-container {
      padding: 41px;
      border: 1px dashed #cccccc;
      border-radius: 2px;
      text-align: center;
      .roo-upload-list-item {
        text-align: center;
        width: 300px;
        span {
          font-weight: 500;
          font-family: PingFangSC-Medium;
          font-size: 14px;
          height: 14px;
          color: #222222;
          line-height: 12px;
          max-width: 300px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          display: inline-block;
        }
      }
    }
  }
  .roo-form-vertical {
    .roo-input-required {
      margin-left: -15px;
    }
  }
  .menu {
    .m-step-idx {
      font-family: YouSheBiaoTiHei;
      font-size: 20px;
      color: #222222;
      letter-spacing: 0;
      text-align: center;
      line-height: 16px;
    }
  }

  &.form-edt {
    .head {
      width: calc(100vw - 48px);
    }
    .body {
      width: calc(100vw - 48px);
      .form-footer {
        position: fixed;
        width: 100%;
        background: #ffffff;
        box-shadow: 0 -2px 6px 0 rgb(0 0 0 / 6%);
        margin-bottom: 0;
        margin-left: 0;
        bottom: 0;
        padding: 10px 0;
        min-width: 1090px;
      }
    }
    .wrap {
      margin-top: 10px;
    }
  }
  &.has-submit {
    .apply {
      padding-bottom: 80px;
    }
  }
  &.has-submit {
    user-select: none;
    .footer {
      margin-top: 24px;
    }
    .wrap {
      margin-top: 10px;
      .head {
        width: calc(100vw - 48px);
      }
      .body {
        width: calc(100vw - 48px);
        .form-footer {
          position: sticky;
          width: 100%;
          background: #ffffff;
          box-shadow: 0 -2px 6px 0 rgb(0 0 0 / 6%);
          margin-bottom: 0;
          margin-left: 0;
          bottom: 0;
          padding: 10px 0;
          min-width: 1090px;
        }
      }
    }
    .help-block {
      display: none;
    }
    .has-error .select-input-wrapper .roo-input,
    .has-error .select-input-wrapper .form-control,
    .has-error .roo-input,
    .has-error .form-control {
      border-color: #e9eaf2 !important;
    }
    .patch-tips,
    .t-info,
    p.info {
      display: none;
      visibility: hidden;
    }
    .hid-view {
      //display: none;
      //visibility: hidden;
    }
  }
`;
export const tipsTitle = {
  scientist: '青山科技奖',
  innovate: '“科创中国”美团青山环保科技创新示范项目',
};

export const Layout = function (props) {
  const { state, update } = useSimpleContext((t) => [
    t.step,
    t.formType,
    t.isViewType,
    t.hasSubmit,
    t.onSubmit,
    t.hasSave,
    t.values,
    t.innovate,
    t.scientist,
    t.loading,
  ]);
  const {
    timestamp, endTimeSci, endTimeIno, load, sciProjectConfigId, inoProjectConfigId,
  } = useUserData();
  const signSci = localStorage.getItem('signSci');
  const signIno = localStorage.getItem('signIno');
  const formType = state.formType;
  const agreeRef = useRef();
  const [visible, setVisible] = useState(false);
  const [checked, setChecked] = useState(
    (formType === 'scientist' && signIno === 'true')
    || (formType === 'innovate' && signSci === 'true'),
  );

  const history = useHistory();

  function setStep(next) {
    update((t) => (t.step = next));
  }
  const step = state.step;
  const config = {
    innovate: {
      title: '"科创中国"美团青山环保科技创新示范项目',
      menus: ['', '基础信息', '附加信息', '申报信息'],
      icons: [],
    },
    scientist: {
      title: '青山科技奖',
      menus: ['', '基础信息', '科研信息', '申报信息'],
      icons: [],
    },
  };
  const t = config[state.formType];

  const getSwitchLink = () => {
    if (!checked) {
      return;
    }
    const newType = state.formType === 'innovate' ? 'scientist' : 'innovate';
    localStorage.setItem(PAGE_TYPE, newType);
    localStorage.setItem(newType === 'scientist' ? 'signSci' : 'signIno', 'true');
    // 签署用户协议
    if (newType === 'scientist' && !signSci) {
      signUserAgreement({ projectConfigId: sciProjectConfigId });
    }

    if (newType === 'innovate' && !signIno) {
      signUserAgreement({ projectConfigId: inoProjectConfigId });
    }

    history.replace({ pathname: `/apply/${newType}` });
    update((t) => {
      t.formType = newType;
      t.step = 1;
    });
    setVisible(false);
  };
  function checkHasChange() {
    const steps = {
      scientist: ['', 'personInfo', 'studyInfo', 'applyInfo'],
      innovate: ['', 'baseInfo', 'additionInfo', 'applyInfo'],
    };
    const v = get(state[state.formType], `iniValues.${steps[state.formType][state.step]}`);
    handleSave({ valid: false, tip: state.hasChange });
  }
  useEffect(() => function () {
    if (state.onSubmit) {
      update((t) => (t.onSubmit = false));
    }
  }, []);

  const { handleSave, saving } = useFormSave();

  if (!load || state.loading) {
    return <Loading backdrop fullscreen visible={!load || state.loading} />;
  }

  if (state.onSubmit && !state.isViewType) {
    return (
      <Root className={Cls('innovate', props.className)}>
        <Header plate={state.isViewType ? '评审平台' : '项目申报'} />
        <Success style={{ marginTop: 10 }} />
      </Root>
    );
  }
  if (timestamp > endTimeSci && timestamp > endTimeIno && !state.hasSubmit) {
    // 全部截止且无项目提交
    return (
      <Root className={Cls('innovate', props.className)}>
        <Header plate={state.isViewType ? '评审平台' : '项目申报'} />
        <TimeLess style={{ marginTop: 10 }} />
      </Root>
    );
  }
  if (state.formType === 'scientist' && timestamp > endTimeSci && !state.hasSubmit) {
    update((t) => (t.formType = 'innovate'));
    history.replace({ pathname: '/apply/innovate' });
    return null;
  }
  if (state.formType === 'innovate' && timestamp > endTimeIno && !state.hasSubmit) {
    update((t) => (t.formType = 'scientist'));
    history.replace({ pathname: '/apply/scientist' });
    return null;
  }
  // 关闭选择科创的入口，如果要开启，则设置为 true
  let enableSwitch = false;
  if (formType === 'innovate' && timestamp > endTimeSci) {
    enableSwitch = false;
  }
  if (formType === 'scientist' && timestamp > endTimeIno) {
    enableSwitch = false;
  }

  return (
    <Root className={Cls('innovate', props.className, state.hasSubmit ? 'has-submit' : 'form-edt')}>
      <Header plate={state.isViewType ? '评审平台' : '项目申报'} />
      <div className="wrap">
        <Box className="head" justifyContent="space-between">
          <span>
            {t.title}
            申报
          </span>
          {!state.isViewType && !state.hasSubmit && enableSwitch && (
            <Box>
              <Button
                type="text"
                onClick={() => {
                  if (!checkHasChange()) {
                    setVisible(true);
                  }
                }}
                style={{ marginRight: 32 }}
              >
                <Icon name="user" size={18} style={{ position: 'relative', top: -1 }} />
                <a style={{ color: '#222' }}>切换申报类型</a>
              </Button>
            </Box>
          )}
        </Box>
        <div className="body" style={{ minHeight: '100vh' }}>
          <ul className="menu" style={{ minWidth: 90 }}>
            {t.menus
              .map((s, idx) => {
                if (!s) {
                  return null;
                }
                const src = step === idx ? step_imgs[idx] : step_imgs_h[idx];
                return (
                  <li
                    key={String(idx)}
                    className={step === idx ? 'active' : ''}
                    onClick={() => {
                      if (step === idx) {
                        return;
                      }
                      if (!checkHasChange()) {
                        setStep(idx);
                      }
                    }}
                  >
                    <span className="m-step-idx">
                      <img src={src} alt="" />
                    </span>
                    {s}
                  </li>
                );
              })
              .filter(Boolean)}
          </ul>
          <div className="cont">
            {props.children}
            <Footer />
          </div>
        </div>
      </div>
      <Agreement
        ref={agreeRef}
        type={state.formType === 'innovate' ? 1 : 2}
        onConfirm={() => {
          setChecked(true);
        }}
      />
      <GlobalStyle />
    </Root>
  );
};
